export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/40">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-7 h-7 flex items-center justify-center">
                <i className="ri-movie-2-line text-primary-500 text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-foreground-200">
                星空电影网
              </span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed">
              主打不缓冲秒开播放体验的高清电影免费在线观看平台。
              高速加载技术保障即点即播，告别等待畅享超清画质影视资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">
              <a href="#media" className="no-underline text-foreground-300 hover:text-primary-400 transition-colors">
                精彩推荐
              </a>
            </h4>
            <ul className="space-y-2">
              <li><a href="#ranking" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline">热播排行榜</a></li>
              <li><a href="#updates" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline">最新上架</a></li>
              <li><a href="#carousel" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline">专题聚焦</a></li>
              <li><a href="#cards" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline">观影指南</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">
              <a href="#topics" className="no-underline text-foreground-300 hover:text-primary-400 transition-colors">
                热门话题
              </a>
            </h4>
            <ul className="space-y-2">
              <li><a href="#features" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline">极致体验</a></li>
              <li><a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline">常见问题</a></li>
              <li><a href="#index" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline">片库索引</a></li>
              <li><a href="#app" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors no-underline">移动观影</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-300 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-600 leading-relaxed">
              欢迎优质影视内容提供方、广告合作商与我们联系，共同打造更丰富的观影生态。
            </p>
            <a
              href="#contact"
              className="inline-block mt-3 text-xs text-primary-500 hover:text-primary-400 transition-colors no-underline"
            >
              合作咨询 →
            </a>
          </div>
        </div>

        <div className="border-t border-background-200/40 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 星空电影网 - 高清电影免费在线观看，不缓冲秒开播放
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors no-underline">回到顶部</a>
            <a href="#about" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors no-underline">关于星空</a>
            <a href="#contact" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors no-underline">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}